import {createI18n} from 'vue-i18n'
import type { I18nOptions } from 'vue-i18n'
import enUS from './locales/en-US'
import ptBR from '@i18n_messages_pt-BR'
import fr from '@i18n_messages_fr'
import es from '@i18n_messages_es'
import pt from '@i18n_messages_pt'
import hu from '@i18n_messages_hu'
import it from '@i18n_messages_it'
import cs from '@i18n_messages_cs'
import de from '@i18n_messages_de'
import nl from '@i18n_messages_nl'
import pl from '@i18n_messages_pl'
import zhCN from '@i18n_messages_zh-CN'
import {datetimeFormats} from './formats'

export const options: I18nOptions = {
    locale: 'en-US',
    silentTranslationWarn: true,
    warnHtmlInMessage: 'off',
    fallbackLocale: {
        'en-US': ['en-US', 'en'],
        'pt-BR': ['pt-BR', 'pt', 'en-US'],
        'pt': ['pt', 'pt-BR', 'en-US'],
        'fr': ['fr', 'en-US'],
        'es': ['es', 'en-US'],
        'hu': ['hu', 'en-US'],
        'it': ['it', 'en-US'],
        'cs': ['cs', 'en-US'],
        'de': ['de', 'en-US'],
        'nl': ['nl', 'en-US'],
        'pl': ['pl', 'en-US'],
        'zh-CN': ['zh-CN', 'en-US']
    },
    messages: {
        'en-US': enUS,
        'pt-BR': ptBR,
        'pt': pt,
        'fr': fr,
        'es': es,
        'hu': hu,
        'it': it,
        'cs': cs,
        'de': de,
        'nl': nl,
        'pl': pl,
        'zh-CN': zhCN
    },
    datetimeFormats: datetimeFormats as unknown as I18nOptions['datetimeFormats'],
}

export const i18n = createI18n<false, typeof options>(options)
